(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('DocumentEventDetailController', DocumentEventDetailController);

    DocumentEventDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'DocumentEvent', 'Document', 'DocumentWorkItem', 'Party'];

    function DocumentEventDetailController($scope, $rootScope, $stateParams, previousState, entity, DocumentEvent, Document, DocumentWorkItem, Party) {
        var vm = this;

        vm.documentEvent = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('jmrsignApp:documentEventUpdate', function(event, result) {
            vm.documentEvent = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
